import { render, staticRenderFns } from "./EditContacts.vue?vue&type=template&id=20759d76&"
import script from "./EditContacts.vue?vue&type=script&lang=js&"
export * from "./EditContacts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports